import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import Wrapper from '../../components/atoms/DirectorioWrapper';
import SidebarProcesosSeleccion from '../../components/pageComponents/SidebarProcesosSeleccion';
import ModalCrearPostulante from '../nuevosPostulantes/ModalCrearPostulante';

interface Metrica {
    titulo: string;
    valor: string;
    icono: any;
    color: string;
    borderColor: string;
}

interface Seccion {
    titulo: string;
    descripcion: string;
    icono: any;
    color: string;
    onClick?: () => void;
}

const GestionProcesosSeleccion: React.FC = () => {
    const history = useHistory();

    // Estados para el modal de crear postulante
    const [showModalCrear, setShowModalCrear] = useState(false);
    const [postulanteToEdit, setPostulanteToEdit] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [showModalMensajeIsPostulanteActivo, setShowModalMensajeIsPostulanteActivo] = useState(false);
    const [mensajeIsPostulanteActivo, setMensajeIsPostulanteActivo] = useState("");

    // Funciones para manejar el modal
    const handleCreatePostulante = () => {
        setIsEditMode(false);
        setPostulanteToEdit(null);
        setShowModalCrear(true);
    };

    const handleCloseModal = () => {
        setShowModalCrear(false);
        setPostulanteToEdit(null);
        setIsEditMode(false);
    };

    const handlePostulanteCreated = (postulante: any, isEdit: boolean = false) => {
        console.log('✅ Postulante creado/editado:', { postulante, isEdit });
        // Aquí podrías agregar lógica para refrescar datos si es necesario
    };

    // Función para navegar a la página de crear evaluación
    const handleCreateEvaluacion = () => {
        console.log('🔵 Navegando a página de crear evaluación (usando EditarEvaluacion sin ID)');
        history.push('/editar-evaluacion');
    };

    // Datos de métricas
    const metricas: Metrica[] = [
        {
            titulo: "Postulaciones Activas",
            valor: "142",
            icono: "users",
            color: "#007bff",
            borderColor: "#007bff"
        },
        {
            titulo: "Evaluaciones Pendientes", 
            valor: "28",
            icono: "clock",
            color: "#fd7e14",
            borderColor: "#fd7e14"
        },
        {
            titulo: "Entrevistas Hoy",
            valor: "6", 
            icono: "eye",
            color: "#28a745",
            borderColor: "#28a745"
        },
        {
            titulo: "Tiempo Promedio (días)",
            valor: "18",
            icono: "chart-line",
            color: "#6f42c1",
            borderColor: "#6f42c1"
        }
    ];

    // Funciones de navegación
    const navegarAPostulantes = () => {
        console.log('🚀 Navegando a postulantes...');
        history.push('/nuevosPostulantes');
    };

    const navegarAEvaluaciones = () => {
        console.log('🚀 Navegando a evaluaciones...');
        history.push('/evaluacionesProcesos');
    };

    // Datos de secciones principales
    const secciones: Seccion[] = [
        {
            titulo: "POSTULANTES",
            descripcion: "Gestión de candidatos",
            icono: "users",
            color: "#007bff",
            onClick: navegarAPostulantes
        },
        {
            titulo: "EVALUACIONES", 
            descripcion: "Listado de evaluaciones",
            icono: "clipboard-list",
            color: "#fd7e14",
            onClick: navegarAEvaluaciones
        },
        {
            titulo: "REPORTES",
            descripcion: "Gráficas y estadísticas", 
            icono: "chart-bar",
            color: "#28a745",
            onClick: () => console.log('Navegar a reportes')
        },
        {
            titulo: "CORREOS",
            descripcion: "Plantillas de comunicación",
            icono: "envelope",
            color: "#6f42c1",
            onClick: () => console.log('Navegar a correos')
        }
    ];

    return (
        <div className="app-wrapper">
          <div className="no-disponible-en-mobile">
            <div style={{ display: 'flex', alignItems: 'stretch' }}>
              <SidebarProcesosSeleccion />
              <Wrapper className="App" style={{ flex: 1, minWidth: 0 }}>
                <Container fluid className="body-content" style={{padding: "40px 30px 30px 30px"}}>
                {/* Header */}
                <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <h1 className="mb-2">Gestión de Procesos de Selección</h1>
                            <p className="text-muted mb-0">Panel centralizado para la administración de talento y vacantes</p>
                        </div>
                        <div className="d-flex gap-3" style={{gap: "15px"}}>
                            <button 
                                className="btn generic-button-buscador light-orange-background-color text-white"
                                style={{backgroundColor: "#fd7e14", border: "none"}}
                                onClick={handleCreatePostulante}
                            >
                                <FontAwesomeIcon icon="plus" className="me-2" /> CREAR POSTULANTE
                            </button>
                            <button 
                                className="btn generic-button-buscador blue-background-color text-white"
                                style={{border: "none"}}
                                onClick={handleCreateEvaluacion}
                            >
                                <FontAwesomeIcon icon="plus" className="me-2" /> CREAR EVALUACIONES
                            </button>
                        </div>
                    </div>
                </div>

                {/* Tarjetas de métricas - Mejoradas para verse más como cards */}
                <Row className="mb-5">
                    {metricas.map((metrica: Metrica, index: number) => (
                        <Col lg={3} md={6} className="mb-3" key={index}>
                            <Card 
                                className="h-100 shadow-sm"
                                style={{
                                    border: "none",
                                    borderLeft: `4px solid ${metrica.borderColor}`,
                                    borderRadius: "8px",
                                    backgroundColor: "#ffffff"
                                }}
                            >
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="flex-grow-1">
                                            <h6 className="text-muted mb-2" style={{fontSize: "0.85rem", fontWeight: 500}}>
                                                {metrica.titulo}
                                            </h6>
                                            <h2 className="font-weight-bold mb-0" style={{fontSize: "2.2rem", color: "#2c3e50", lineHeight: "1"}}>
                                                {metrica.valor}
                                            </h2>
                                        </div>
                                        <div 
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{
                                                width: "50px",
                                                height: "50px", 
                                                backgroundColor: "#f8f9fa",
                                                borderRadius: "8px"
                                            }}
                                        >
                                            <FontAwesomeIcon 
                                                icon={metrica.icono} 
                                                style={{color: "#6c757d", fontSize: "20px"}}
                                            />
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* Tarjetas de secciones principales - Mantener como botones grandes */}
                <Row>
                    {secciones.map((seccion: Seccion, index: number) => (
                        <Col lg={3} md={6} className="mb-4" key={index}>
                            <Card 
                                className="h-100 border-0 shadow-sm cursor-pointer"
                                style={{
                                    transition: "all 0.3s ease",
                                    cursor: "pointer"
                                }}
                                onClick={seccion.onClick}
                                onMouseEnter={(e: React.MouseEvent<HTMLDivElement>) => {
                                    const target = e.currentTarget;
                                    target.style.transform = "translateY(-5px)";
                                    target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
                                }}
                                onMouseLeave={(e: React.MouseEvent<HTMLDivElement>) => {
                                    const target = e.currentTarget;
                                    target.style.transform = "translateY(0)";
                                    target.style.boxShadow = "0 2px 10px rgba(0,0,0,0.1)";
                                }}
                            >
                                <Card.Body className="text-center p-4" style={{backgroundColor: seccion.color + "05"}}>
                                    <div 
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                        style={{
                                            width: "80px",
                                            height: "80px",
                                            backgroundColor: seccion.color + "20"
                                        }}
                                    >
                                        <FontAwesomeIcon 
                                            icon={seccion.icono} 
                                            size="2x"
                                            style={{color: seccion.color}}
                                        />
                                    </div>
                                    <h5 className="font-weight-bold mb-2" style={{color: "#333"}}>
                                        {seccion.titulo}
                                    </h5>
                                    <p className="text-muted mb-0" style={{fontSize: "0.9rem"}}>
                                        {seccion.descripcion}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* Modal de crear postulante */}
                {showModalCrear && (
                    <div className="modal-contactanos modal-response-ficha-background">
                        <ModalCrearPostulante
                            showModal={showModalCrear}
                            setShowModal={handleCloseModal}
                            onPostulanteCreated={handlePostulanteCreated}
                            postulanteToEdit={postulanteToEdit}
                            isEditMode={isEditMode}
                            setShowModalMensajeIsPostulanteActivo={setShowModalMensajeIsPostulanteActivo}
                            setMensajeIsPostulanteActivo={setMensajeIsPostulanteActivo}
                        />
                    </div>
                )}
            </Container>
              </Wrapper>
            </div>
          </div>
        </div>
    );
};

export default GestionProcesosSeleccion;